import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TablerIconsModule} from "angular-tabler-icons";
import {CommonModule} from "@angular/common";
import {FormArray, FormGroup} from "@angular/forms";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {LocalizationPipe} from "../../../../../pipe/localization-pipe";

@Component({
  selector: 'app-user-decision-options',
  imports: [
    CommonModule,
    TablerIconsModule,
    MatSlideToggle,
    LocalizationPipe,
  ],
  templateUrl: './user-decision-options.component.html',
  styleUrl: './user-decision-options.component.scss'
})
export class UserDecisionOptionsComponent implements OnInit,OnChanges {
  @Input() uploadedFiles: any;
  @Input() uploadedFilesLength: any;
  @Input() sheetIndexOfExcel: number;
  @Input() getOptionTypeIcon: (key: string) => string = () => 'info-circle';
  @Input() formGroup: any;
  @Output() userDecisionChange = new EventEmitter<[string, boolean, number]>();
  categorizedFormGroupKeys: { [key: string]: any[] } = {};

  constructor() {

  }

  ngOnInit(): void {
    this.initializeFormGroupKeys()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["uploadedFilesLength"]) {
      this.initializeFormGroupKeys()
    }
  }

  private initializeFormGroupKeys() {
    if (this.formGroup.get('organizationSheetName')) {
      return;
    }
    this.categorizedFormGroupKeys = {};
    let availableFileTypes: string[] = [];
    if (this.uploadedFilesLength) {
      availableFileTypes = this.getFileTypes()
    }
    if (this.formGroup.get('sheets')) {
      Object.keys(((this.formGroup.get('sheets') as FormArray).at(this.sheetIndexOfExcel) as FormGroup).controls)
        .filter(key => key !== 'sheetHeaders' && key !== 'sheetIndex' && key !== 'uploadedFiles')
        .forEach(key => {
          const control = ((this.formGroup.get('sheets') as FormArray)?.at(this.sheetIndexOfExcel) as FormGroup).get(key);
        const controlValue = control.getRawValue();
        if (typeof controlValue.value === 'boolean') {
          const type = controlValue.type[0];
          if (availableFileTypes.includes(type)) {
            if (!this.categorizedFormGroupKeys[type]) {
              this.categorizedFormGroupKeys[type] = [];
            }
            this.categorizedFormGroupKeys[type].push({
              key,
              control,
              sheetIndex: this.sheetIndexOfExcel,
            });
          }
        }
      });
    } else {
      Object.keys(this.formGroup.controls)
        .filter(key => key !== 'uploadedFiles')
        .forEach(key => {
          const control = this.formGroup.get(key);
          const controlValue = control.getRawValue();

          if (typeof controlValue.value === 'boolean') {
            const type = controlValue.type[0];
            if (availableFileTypes.includes(type)) {
              if (!this.categorizedFormGroupKeys[type]) {
                this.categorizedFormGroupKeys[type] = [];
              }
              this.categorizedFormGroupKeys[type].push({
                key,
                control,
                sheetIndex: null
              });
            }
          }
        });
    }
  }

  private getFileTypes(): string[] {
    return this.uploadedFiles.map(file => {
      const extension = file.name.split('.').pop()?.toLowerCase();
      switch(extension) {
        case 'pdf':
          return 'pdf';
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
          return 'image';
        case 'mp4':
        case 'avi':
        case 'mov':
          return 'video';
        case 'xlsx':
        case 'xls':
        case 'csv':
        case 'ods':
          return 'excel';
        case 'doc':
        case 'docx':
          return 'doc';
        case 'txt':
        case 'md':
          return 'txt';
        default:
          return '';
      }
    });
  }

  changeOptions($event, key, sheetIndex: number){
    sheetIndex !== null ? this.userDecisionChange.emit([key, $event.checked, sheetIndex]) : this.userDecisionChange.emit([key, $event.checked, null])
  }

  getControlValue(control: any): boolean {
    return control.getRawValue().value;
  }

}
